import React, { useEffect, useState } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import axios from "axios";
import { baseurl } from "../../baseurl";
import { FaRupeeSign } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function MedicineStock() {
  const [medicines, setMedicines] = useState([]);
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // 🔍 Filter when search changes
  useEffect(() => {
    const q = search.toLowerCase();
    const result = medicines.filter((m) =>
      m.name.toLowerCase().includes(q)
    );
    setFilteredMedicines(result);
  }, [search, medicines]);

  // 🟢 Fetch Medicines
  const fetchMedicines = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}getMedicines`);
      setMedicines(res.data || []);
      setFilteredMedicines(res.data || []);
    } catch (err) {
      console.error("Error fetching medicines:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedicines();
  }, []);

  // 💰 Calculate Total Stock Value
  const totalStockValue = filteredMedicines.reduce(
    (sum, m) => sum + (m.stock * m.cost_price || 0),
    0
  );

  // 📤 Export to Excel
  const exportToExcel = () => {
    const exportData = filteredMedicines.map((m, index) => ({
      "#": index + 1,
      Name: m.name,
      Stock: m.stock,
      "Cost / Unit (₹)": m.cost_price,
      "Total Cost (₹)": (m.stock * m.cost_price).toFixed(2),
      Expiry: new Date(m.expiry_date).toLocaleDateString("en-GB"),
      Status: m.status,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Medicine Stock");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(data, "Medicine_Stock.xlsx");
  };

  return (
    <>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper">
        <div className="main-content">

          {/* 🧾 Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title mb-0">💊 Medicine Stock Summary</h4>
            <button
              onClick={exportToExcel}
              className="btn btn-success btn-sm shadow-sm"
            >
              📊 Export Excel
            </button>
          </div>

          {/* 🔍 Search Input */}
          {/* <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search medicine by name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div> */}

          {/* 💰 Total Stock Value */}
          <div className="row mb-3">
            <div className="col-md-4 col-lg-4 col-6">
              <div className="summary-card card-gradient-purple">
                <div className="summary-icon">
                  <FaRupeeSign />
                </div>
                <div className="summary-info">
                  <h6 className="text-white">Total Stock Value</h6>
                  <h4 className="text-white">₹{totalStockValue.toFixed(2)}</h4>
                </div>
              </div>
            </div>
          </div>

          {/* 📋 Medicine Table */}
          <div className="card shadow-sm border-0">
            
            <div className="card-body table-responsive">

              <input
              type="text"
              className="form-control"
              placeholder="Search medicine by name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />


              {loading ? (
                <p className="text-center py-4">Loading medicines...</p>
              ) : (
                <table className="table table-striped align-middle text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Stock</th>
                      <th>Cost / Unit ₹</th>
                      <th>Total Cost ₹</th>
                      <th>Expiry</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredMedicines.length > 0 ? (
                      filteredMedicines.map((m, i) => (
                        <tr key={m.id}>
                          <td>{i + 1}</td>
                          <td className="fw-semibold text-start">{m.name}</td>
                          <td>{m.stock}</td>
                          <td>₹{Number(m.cost_price || 0).toFixed(2)}</td>
                          <td className="fw-bold text-primary">
                            ₹{(m.stock * m.cost_price).toFixed(2)}
                          </td>
                          <td>
                            {new Date(m.expiry_date) < new Date() ? (
                              <span className="badge bg-danger">
                                {new Date(m.expiry_date).toLocaleDateString("en-GB")}
                              </span>
                            ) : (
                              <span className="badge bg-success">
                                {new Date(m.expiry_date).toLocaleDateString("en-GB")}
                              </span>
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge px-2 py-1 ${
                                m.status === "active"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {m.status}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-3">
                          No medicines found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>

        </div>
      </main>
    </>
  );
}

export default MedicineStock;
